export const degrees2radians = (degree: number): number => {
	return degree * (Math.PI / 180);
};
